import React from 'react';

import GlobalStyles from '../styles/GlobalStyles';
import 'normalize.css';
import Header from './Header';
import SEO from './SEO';
import { LocaleProvider } from './localeContext'


export default function Layout({ children, pageContext, data, }) {
  return (
    <>
      <GlobalStyles />
      <SEO
        location={pageContext.locale} children={children}
      />
      <LocaleProvider locale={pageContext.locale}>
        <Header data={data.sanityNavigation} />
      </LocaleProvider>
      <div id="main-section">
        {children}
      </div>
    </>
  );
}
